__turbopack_context__.v({
  "card": "V82Wiq_card",
  "cardLayer": "V82Wiq_cardLayer",
  "fadeIn": "V82Wiq_fadeIn",
});
